export const LOGIN = {
    slogan: "Savor the taste of happiness – Fast, fresh, and always delicious!",
}